var exports = {
  "UE": "x43aef4ae--ce6642--arrow",
  "Pr": "x43aef4ae--ce6642--arrow--left",
  "m1": "x43aef4ae--ce6642--arrow--right",
};

module.exports = exports;
